"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadRewards = loadRewards;
exports.loadReward = loadReward;
exports.loadRewardRedeemedUsers = loadRewardRedeemedUsers;
exports.createReward = createReward;
exports.editReward = editReward;
exports.deleteReward = deleteReward;
exports.extractReward = extractReward;
exports.watchLoadRewards = watchLoadRewards;
exports.watchLoadReward = watchLoadReward;
exports.watchloadRewardRedeemedUsers = watchloadRewardRedeemedUsers;
exports.watchCreateReward = watchCreateReward;
exports.watchDeleteReward = watchDeleteReward;
exports.watchEditReward = watchEditReward;
exports.watchExtractReward = watchExtractReward;
exports["default"] = exports.rewardsSagas = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _actions = _interopRequireDefault(require("./actions"));

var _utils = require("../../utils");

var _utils2 = require("./utils");

var _marked = _regenerator["default"].mark(loadRewards),
    _marked2 = _regenerator["default"].mark(loadReward),
    _marked3 = _regenerator["default"].mark(loadRewardRedeemedUsers),
    _marked4 = _regenerator["default"].mark(createReward),
    _marked5 = _regenerator["default"].mark(editReward),
    _marked6 = _regenerator["default"].mark(deleteReward),
    _marked7 = _regenerator["default"].mark(extractReward),
    _marked8 = _regenerator["default"].mark(watchLoadRewards),
    _marked9 = _regenerator["default"].mark(watchLoadReward),
    _marked10 = _regenerator["default"].mark(watchloadRewardRedeemedUsers),
    _marked11 = _regenerator["default"].mark(watchCreateReward),
    _marked12 = _regenerator["default"].mark(watchDeleteReward),
    _marked13 = _regenerator["default"].mark(watchEditReward),
    _marked14 = _regenerator["default"].mark(watchExtractReward);

function loadRewards(api, action) {
  var _action$payload, _action$payload$query, query, _action$payload$index, index, _action$payload$searc, searchOptions, filters, rewardSearchOptions, data;

  return _regenerator["default"].wrap(function loadRewards$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _action$payload = action.payload, _action$payload$query = _action$payload.query, query = _action$payload$query === void 0 ? '' : _action$payload$query, _action$payload$index = _action$payload.index, index = _action$payload$index === void 0 ? 'rewards' : _action$payload$index, _action$payload$searc = _action$payload.searchOptions, searchOptions = _action$payload$searc === void 0 ? {
            hitsPerPage: 20,
            page: 0
          } : _action$payload$searc, filters = _action$payload.filters;
          rewardSearchOptions = (0, _utils2.getRewardSearchOptions)(searchOptions, filters);
          _context.next = 5;
          return api.getRewardsByQuery({
            query: query,
            index: index,
            searchOptions: rewardSearchOptions
          }).then(function (data) {
            return data;
          });

        case 5:
          data = _context.sent;
          _context.next = 8;
          return (0, _effects.put)(_actions["default"].loadRewardsSuccess(data));

        case 8:
          _context.next = 14;
          break;

        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](0);
          _context.next = 14;
          return (0, _effects.put)(_actions["default"].loadRewardsError(_context.t0));

        case 14:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0, 10]]);
}

function loadReward(api, action) {
  var _action$payload2, rewardId, _action$payload2$clie, clientId, _action$payload2$noCa, noCache, data;

  return _regenerator["default"].wrap(function loadReward$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _action$payload2 = action.payload, rewardId = _action$payload2.rewardId, _action$payload2$clie = _action$payload2.clientId, clientId = _action$payload2$clie === void 0 ? undefined : _action$payload2$clie, _action$payload2$noCa = _action$payload2.noCache, noCache = _action$payload2$noCa === void 0 ? false : _action$payload2$noCa;
          _context2.next = 4;
          return api.getReward({
            rewardId: rewardId,
            clientId: clientId,
            noCache: noCache
          });

        case 4:
          data = _context2.sent;
          _context2.next = 7;
          return (0, _effects.put)(_actions["default"].loadRewardSuccess(data));

        case 7:
          _context2.next = 13;
          break;

        case 9:
          _context2.prev = 9;
          _context2.t0 = _context2["catch"](0);
          _context2.next = 13;
          return (0, _effects.put)(_actions["default"].loadRewardError(_context2.t0));

        case 13:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[0, 9]]);
}

function loadRewardRedeemedUsers(api, action) {
  var _action$payload3, rewardId, search, _action$payload3$skip, skip, _action$payload3$limi, limit, data;

  return _regenerator["default"].wrap(function loadRewardRedeemedUsers$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _action$payload3 = action.payload, rewardId = _action$payload3.rewardId, search = _action$payload3.search, _action$payload3$skip = _action$payload3.skip, skip = _action$payload3$skip === void 0 ? 0 : _action$payload3$skip, _action$payload3$limi = _action$payload3.limit, limit = _action$payload3$limi === void 0 ? 20 : _action$payload3$limi;
          _context3.next = 4;
          return api.getRewardRedeemedUsers({
            rewardId: rewardId,
            search: search,
            skip: skip,
            limit: limit
          }).then(function (p) {
            return p.request;
          });

        case 4:
          data = _context3.sent;
          _context3.next = 7;
          return (0, _effects.put)(_actions["default"].loadRewardRedeemedUsersSuccess(data));

        case 7:
          _context3.next = 13;
          break;

        case 9:
          _context3.prev = 9;
          _context3.t0 = _context3["catch"](0);
          _context3.next = 13;
          return (0, _effects.put)(_actions["default"].loadRewardRedeemedUsersError(_context3.t0));

        case 13:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[0, 9]]);
}

function createReward(api, action) {
  var _action$payload4, data, clientId, _createReward;

  return _regenerator["default"].wrap(function createReward$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _action$payload4 = action.payload, data = _action$payload4.data, clientId = _action$payload4.clientId;
          _context4.next = 4;
          return api.createReward({
            data: data,
            clientId: clientId
          }).then(function (p) {
            return p.request;
          });

        case 4:
          _createReward = _context4.sent;
          _context4.next = 7;
          return (0, _effects.put)(_actions["default"].createRewardSuccess(_createReward._id));

        case 7:
          _context4.next = 13;
          break;

        case 9:
          _context4.prev = 9;
          _context4.t0 = _context4["catch"](0);
          _context4.next = 13;
          return (0, _effects.put)(_actions["default"].createRewardError(_context4.t0));

        case 13:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[0, 9]]);
}

function editReward(api, action) {
  var _action$payload5, data, clientId, rewardId;

  return _regenerator["default"].wrap(function editReward$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          _action$payload5 = action.payload, data = _action$payload5.data, clientId = _action$payload5.clientId, rewardId = _action$payload5.rewardId;
          _context5.next = 4;
          return api.editReward({
            data: data,
            clientId: clientId,
            rewardId: rewardId
          }).then(function (p) {
            return p.request;
          });

        case 4:
          _context5.next = 6;
          return (0, _effects.put)(_actions["default"].editRewardSuccess(rewardId));

        case 6:
          _context5.next = 12;
          break;

        case 8:
          _context5.prev = 8;
          _context5.t0 = _context5["catch"](0);
          _context5.next = 12;
          return (0, _effects.put)(_actions["default"].editRewardError(_context5.t0));

        case 12:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5, null, [[0, 8]]);
}

function deleteReward(api, action) {
  var _action$payload6, rewardId, clientId;

  return _regenerator["default"].wrap(function deleteReward$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.prev = 0;
          _action$payload6 = action.payload, rewardId = _action$payload6.rewardId, clientId = _action$payload6.clientId;
          _context6.next = 4;
          return api.deleteReward({
            rewardId: rewardId,
            clientId: clientId
          }).then(function (p) {
            return p.request;
          });

        case 4:
          _context6.next = 6;
          return (0, _effects.put)(_actions["default"].deleteRewardSuccess());

        case 6:
          _context6.next = 12;
          break;

        case 8:
          _context6.prev = 8;
          _context6.t0 = _context6["catch"](0);
          _context6.next = 12;
          return (0, _effects.put)(_actions["default"].deleteRewardError(_context6.t0));

        case 12:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6, null, [[0, 8]]);
}

function extractReward(api, action) {
  var _action$payload7, rewardId, clientId, data;

  return _regenerator["default"].wrap(function extractReward$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.prev = 0;
          _action$payload7 = action.payload, rewardId = _action$payload7.rewardId, clientId = _action$payload7.clientId;
          _context7.next = 4;
          return api.extractReward({
            rewardId: rewardId,
            clientId: clientId
          }).then(function (p) {
            return p.request;
          });

        case 4:
          data = _context7.sent;
          _context7.next = 7;
          return (0, _effects.put)(_actions["default"].extractRewardSuccess(data));

        case 7:
          _context7.next = 13;
          break;

        case 9:
          _context7.prev = 9;
          _context7.t0 = _context7["catch"](0);
          _context7.next = 13;
          return (0, _effects.put)(_actions["default"].extractRewardError(_context7.t0));

        case 13:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7, null, [[0, 9]]);
}

function watchLoadRewards(api) {
  return _regenerator["default"].wrap(function watchLoadRewards$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].loadRewards), loadRewards, api);

        case 2:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8);
}

function watchLoadReward(api) {
  return _regenerator["default"].wrap(function watchLoadReward$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].loadReward), loadReward, api);

        case 2:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked9);
}

function watchloadRewardRedeemedUsers(api) {
  return _regenerator["default"].wrap(function watchloadRewardRedeemedUsers$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].loadRewardRedeemedUsers), loadRewardRedeemedUsers, api);

        case 2:
        case "end":
          return _context10.stop();
      }
    }
  }, _marked10);
}

function watchCreateReward(api) {
  return _regenerator["default"].wrap(function watchCreateReward$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].createReward), createReward, api);

        case 2:
        case "end":
          return _context11.stop();
      }
    }
  }, _marked11);
}

function watchDeleteReward(api) {
  return _regenerator["default"].wrap(function watchDeleteReward$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].deleteReward), deleteReward, api);

        case 2:
        case "end":
          return _context12.stop();
      }
    }
  }, _marked12);
}

function watchEditReward(api) {
  return _regenerator["default"].wrap(function watchEditReward$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].editReward), editReward, api);

        case 2:
        case "end":
          return _context13.stop();
      }
    }
  }, _marked13);
}

function watchExtractReward(api) {
  return _regenerator["default"].wrap(function watchExtractReward$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].extractReward), extractReward, api);

        case 2:
        case "end":
          return _context14.stop();
      }
    }
  }, _marked14);
}

var rewardsSagas = function rewardsSagas(api) {
  return [(0, _effects.fork)(watchLoadRewards, api), (0, _effects.fork)(watchLoadReward, api), (0, _effects.fork)(watchloadRewardRedeemedUsers, api), (0, _effects.fork)(watchCreateReward, api), (0, _effects.fork)(watchDeleteReward, api), (0, _effects.fork)(watchEditReward, api), (0, _effects.fork)(watchExtractReward, api)];
};

exports.rewardsSagas = rewardsSagas;
var _default = rewardsSagas;
exports["default"] = _default;
//# sourceMappingURL=sagas.js.map